import { render, staticRenderFns } from "./CustomLargeCard.vue?vue&type=template&id=8b01ec3e&scoped=true"
import script from "./CustomLargeCard.vue?vue&type=script&lang=js"
export * from "./CustomLargeCard.vue?vue&type=script&lang=js"
import style0 from "./CustomLargeCard.vue?vue&type=style&index=0&id=8b01ec3e&prod&scoped=true&lang=scss"
import style1 from "./CustomLargeCard.vue?vue&type=style&index=1&id=8b01ec3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b01ec3e",
  null
  
)

export default component.exports